import {
  deleteAdminV1StoresStoreIdShippingRatesId,
  deleteAdminV1StoresStoreIdShippingZonesId,
  getAdminV1StoresStoreIdShippingZones,
  patchAdminV1StoresStoreIdShippingRatesId,
  patchAdminV1StoresStoreIdShippingZonesId,
  postAdminV1StoresStoreIdShippingZones,
  postAdminV1StoresStoreIdShippingZonesIdRates,
  type PatchAdminV1StoresStoreIdShippingRatesIdBody,
  type PatchAdminV1StoresStoreIdShippingZonesIdBody,
  type PostAdminV1StoresStoreIdShippingZonesBody,
  type PostAdminV1StoresStoreIdShippingZonesIdRatesBody,
  type ShippingRate,
  type ShippingZone,
} from '@nucleus-commerce/api-client/admin';

/** Shipping zones of one store, each with its rates: a bounded `{ items }` list. */
export const shippingApi = {
  listZones: (storeId: string): Promise<ShippingZone[]> =>
    getAdminV1StoresStoreIdShippingZones({ storeId }).then((r) => r.items),
  createZone: (
    storeId: string,
    body: PostAdminV1StoresStoreIdShippingZonesBody,
  ): Promise<ShippingZone> => postAdminV1StoresStoreIdShippingZones({ storeId }, body),
  updateZone: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdShippingZonesIdBody,
  ): Promise<ShippingZone> => patchAdminV1StoresStoreIdShippingZonesId({ storeId, id }, body),
  removeZone: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdShippingZonesId({ storeId, id }),

  createRate: (
    storeId: string,
    zoneId: string,
    body: PostAdminV1StoresStoreIdShippingZonesIdRatesBody,
  ): Promise<ShippingRate> =>
    postAdminV1StoresStoreIdShippingZonesIdRates({ storeId, id: zoneId }, body),
  updateRate: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdShippingRatesIdBody,
  ): Promise<ShippingRate> => patchAdminV1StoresStoreIdShippingRatesId({ storeId, id }, body),
  removeRate: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdShippingRatesId({ storeId, id }),
};
